import get from 'lodash/get';

export const FORM_SUBMITTED = 'FORM_SUBMITTED';

export const receiveForm = (formName: unknown, form: unknown) => ({
  type: FORM_SUBMITTED,
  formName,
  form,
});

export const getRepeatablePath = (key: string, state: object) => {
  const componentId = get(state, 'form.id');
  const propPath = key.split('.').slice(1);
  return [componentId, ...propPath];
};
